export default "__VITE_ASSET__BWN4V6Wu__"